// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tabs--g1TCF"};